export default "__VITE_ASSET__I84asmjF__"